/* eslint-disable quotes */
import { CLIENT_NAME, HOSTNAME } from '@/utils'
import type { TypeLang, TypeJsonLdHomepageData } from '@/schema'
import { buildUrl, getIetfLang } from './_url'
import { buildOrganization } from './_organization'

export function jsonLdHomepage(data: TypeJsonLdHomepageData, locale: TypeLang) {
  const url = buildUrl(locale)

  const schema = {
    "@context": "https://schema.org",
    "@graph": [
      {
        "@type": "WebSite",
        "@id": `${url}/#website`,
        "url": url,
        "name": CLIENT_NAME,
        "description": data.description,
        "inLanguage": getIetfLang(locale),
        "publisher": {
          "@id": `${url}/#organization`
        },
        "potentialAction": {
          "@type": "SearchAction",
          "target": {
            "@type": "EntryPoint",
            "urlTemplate": `https://${HOSTNAME}/${locale}/search?q={search_term_string}`
          },
          "query-input": "required name=search_term_string"
        }
      },
      {
        ...buildOrganization(locale, 'full'),
        "@id": `${url}/#organization`
      }
    ]
  }

  return JSON.stringify(schema)
}
